import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { addCourseApi, getCourseApi, updateCourseApi } from "../../../Api/Course";

interface Props {
  url: string;
  courseId: string | null;
  onClose: () => void;
  onSaved?: () => void;
}

export function CourseForm({ url, courseId, onClose , onSaved}: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const id = courseId;

  const [CourseName, setCourseName] = useState("");
  const [targetGender, setTargetGender] = useState("All");

  const [isEdit, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [, setCfId] = useState<string>("");
  const [Id, setId] = useState("");

  useEffect(() => {
    const handleApiClick = async () => {
      try {
        if (id) {
          const courseData: any = await getCourseApi(url); // Adjust based on the actual structure
          const courseToEdit = courseData.find(
            (course: any) => course.id === id
          );
          if (courseToEdit) {
            setId(courseToEdit.id);
            setCourseName(courseToEdit.name);
            let targetGender = "All";

            if (courseToEdit.gender === null) {
              targetGender = "All";
            } else if (courseToEdit.gender === 0) {
              targetGender = "Male";
            } else if (courseToEdit.gender === 1) {
              targetGender = "Female";
            }
            setTargetGender(targetGender);
            setIsEditMode(true);
            setLoading(false);
          }
        }
      } catch (error) {
        toast.error("Failed to fetch Course", { id: "fetchError" });
        setHasError(true);
        setLoading(false);
      }
    };
    handleApiClick();
  }, [id, navigate]);

  useEffect(() => {
    if (id) {
      setCfId(id);
      setIsEditMode(true);
      setLoading(true);
    } else {
      setIsEditMode(false);
      setLoading(false);
    }
  }, [id]);

  const handleResetForm = () => {
    setCourseName("");
    onClose();
  };

  const handleSubmitClick = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!CourseName) {
      toast.error("Please fill all the fields")
      return;
    }

    try {
      var gender = null;

      if (targetGender === "Male") {
        gender = 0;
      } else if (targetGender === "Female") {
        gender = 1;
      }

      if (isEdit) {
        await updateCourseApi(Id, CourseName, gender, url);
        toast.success("Course updated successfully");
      } else {
        await addCourseApi(CourseName, gender, url);
        toast.success("Course Added Successfully");
      }
      if( onSaved) 
        onSaved();
      onClose();
      // navigate("/admin/Course");
    } catch (error) {
      toast.error(isEdit ? "Failed to update Course" : "Unable to add Course");
    }

    setCourseName("");
  };

  return (

        <div>
          {loading ? (
            <div className="flex justify-center items-center h-screen">
              <div
                className="flex justify-center items-center h-12 w-12 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] text-blue-600"
                role="status"
              >
                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                  Loading...
                </span>
              </div>
            </div>
          ) : hasError ? (
            <div className="flex justify-center items-center h-screen">
              {/* Blank page when there’s an error */}
            </div>
          ) : (
            <>
              <h2 className="text-3xl font-bold text-blue-600 mb-5">
                Course Form
              </h2>
              <form onSubmit={handleSubmitClick} className="mt-8 space-y-4">
                <div className="flex flex-col gap-4">
                  <div>
                    <label
                      htmlFor="bankName"
                      className="block text-sm font-medium text-black dark:text-gray-200 mb-2"
                    >
                      Course Name
                    </label>
                    <input
                      id="courseName"
                      type="text"
                      required
                      placeholder="Course Name"
                      value={CourseName}
                      onChange={(event) => setCourseName(event.target.value)}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="flex flex-col space-y-2">
                    <label
                      htmlFor="targetGender"
                      className="block text-sm font-medium text-black dark:text-gray-200 mb-2"
                    >
                      Target Audience:
                    </label>
                    <select
                      id="targetGender"
                      className="p-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500"
                      value={targetGender}
                      onChange={(e) => setTargetGender(e.target.value)}
                      required
                    >
                      <option value="All" selected>
                        All
                      </option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                </div>
                <div className="flex justify-start space-x-4">
                  <button
                    type="submit"
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {isEdit ? "Update" : "Save and close"}
                  </button>
                  <button
                    type="button"
                    onClick={handleResetForm}
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-gray-300"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </>
          )}
        </div>

  );
}
